import { apiSlice } from './api';
import type { RootState } from '../store';
const { VITE_API_BASE_URL } = import.meta.env;

export interface UploadedFile {
  url: string;
  path: string;
  file_type: string;
  mime_type: string;
}

export interface MediaUploadResponse {
  status: string;
  message: string;
  data: UploadedFile[];
}

export const mediaApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadMedia: builder.mutation<
      MediaUploadResponse,
      { files: File[]; directory?: string }
    >({
      // Uses queryFn to bypass the /admin base URL — media endpoint is at /api/v1/media/upload
      queryFn: async ({ files, directory }, { getState }) => {
        const form = new FormData();
        files.forEach((f) => form.append('file[]', f));
        if (directory) form.append('directory', directory);

        const token = (getState() as RootState).auth.token;

        try {
          const res = await fetch(
            `${VITE_API_BASE_URL}/media/upload`,
            {
              method: 'POST',
              body: form,
              credentials: 'include',
              headers: {
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
                'Accept-Language': 'en',
              },
            }
          );
          const data = (await res.json()) as MediaUploadResponse;
          if (!res.ok) return { error: { status: res.status, data } };
          return { data };
        } catch (error) {
          return { error: { status: 'FETCH_ERROR', error: String(error) } };
        }
      },
    }),
  }),
});

export const { useUploadMediaMutation } = mediaApi;
